import {ActionTree} from 'vuex';
import axios from 'axios';
import {RootState} from '@/store/types';
import {StatisticState, DetailFilterParams, GroupFilterParams} from './types';

export const actions: ActionTree<StatisticState, RootState> = {
  async getCallStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    try {
      let resp = await axios({
        url: '/stats-api/detail/call',
        params: data,
      });
      let messages = resp.data?.messages ?? []
      if (data.page_number > 1) {
        commit('pushCallStatisticDetail', messages);
      } else {
        commit('setCallStatisticDetail', messages);
      }
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportCallStatisticDetail({commit, dispatch}, data: DetailFilterParams) {
    try {
      let resp = await axios({
        url: '/stats-api/detail/call/export',
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getCallStatisticDetailInfo({ commit, dispatch }, id: string) {
    try {
      const resp = await axios({
        url: "/stats-api/detail/call/" + id.replace(/#/g, "%23"),
      });
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async getCallEvents({commit}, id: string) {
    try {
      const resp = await axios({
        url: `/stats-api/detail/call/${id.replace(/#/g, "%23")}/events`,
      })
      return resp.data;
    } catch (err) {
      throw err;
    }
  },
  async getCallStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/call',
        params: data,
      });
      commit('setCallStatisticGroup', resp.data);
      return resp;
    } catch (err) {
      throw err;
    }
  },
  async exportCallStatisticGroup({commit}, data: GroupFilterParams) {
    try {
      const resp = await axios({
        url: '/stats-api/group/call/export',
        params: data,
      });
      return resp;
    } catch (err) {
      throw err;
    }
  }
};